export const COOKIE_CONSENT_KEY = "fg_cookie_consent";
export const COOKIE_CONSENT_VALUES = {
  ALL: "all",
  NECESSARY: "necessary",
  NONE: "none",
};
export const COOKIE_NO_CONTENT_ICON = "/assets/images/disabled_icon.svg";
export const COOKIE_ICON = "/assets/images/cookie_icon.svg";

export const SYNC_WARNING_COOKIE_VALUE = "true";
export const SYNC_WARNING_COOKIE_EXPIRY_DAYS = 1;
export const SYNC_WARNING_DONT_SHOW_EXPIRY_DAYS = 365;
